/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ai_ErrorInputs */

const en_ai_error = /** @type {(inputs: Ai_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI Error`)
};

const es_ai_error = /** @type {(inputs: Ai_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error de IA`)
};

const fr_ai_error = /** @type {(inputs: Ai_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erreur IA`)
};

const de_ai_error = /** @type {(inputs: Ai_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KI-Fehler`)
};

const ja_ai_error = /** @type {(inputs: Ai_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AIエラー`)
};

const zh_ai_error = /** @type {(inputs: Ai_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI 错误`)
};

const ar_ai_error = /** @type {(inputs: Ai_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`خطأ في الذكاء الاصطناعي`)
};

const id_ai_error = /** @type {(inputs: Ai_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kesalahan AI`)
};

const it_ai_error = /** @type {(inputs: Ai_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Errore IA`)
};

const ru_ai_error = /** @type {(inputs: Ai_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ошибка ИИ`)
};

const pt_ai_error = /** @type {(inputs: Ai_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erro de IA`)
};

const ko_ai_error = /** @type {(inputs: Ai_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI 오류`)
};

/**
* | output |
* | --- |
* | "AI Error" |
*
* @param {Ai_ErrorInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const ai_error = /** @type {((inputs?: Ai_ErrorInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ai_ErrorInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ai_error(inputs)
	if (locale === "es") return es_ai_error(inputs)
	if (locale === "fr") return fr_ai_error(inputs)
	if (locale === "de") return de_ai_error(inputs)
	if (locale === "ja") return ja_ai_error(inputs)
	if (locale === "zh") return zh_ai_error(inputs)
	if (locale === "ar") return ar_ai_error(inputs)
	if (locale === "id") return id_ai_error(inputs)
	if (locale === "it") return it_ai_error(inputs)
	if (locale === "ru") return ru_ai_error(inputs)
	if (locale === "pt") return pt_ai_error(inputs)
	return ko_ai_error(inputs)
});